<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Activating from your Software
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>

            <p>
                If you are activating the software for the first time, or after a move to a new computer, or you have changed hardware components
                in your existing computer, you will require a new Activation Code. Once you have the software installed,
                follow these steps to activate your new installation.
            </p>

            <p>
                If you have any connectivity problems, or if you have multiple licenses in your account, use the <router-link to="/support/help/account-activate">Activating from your Account</router-link> option instead.
            </p>

            <p>
                If you need the setup file to install the software, go to the corresponding downloads page:
            </p>

            <ul style='list-style-type: none;' class='helpTable'>
                <li><router-link to='/Download/LoopCAD'>Download LoopCAD</router-link></li>
                <li><router-link to='/Download/HeatCAD'>Download HeatCAD</router-link></li>
                <li><router-link to='/Download/PlumbingCAD'>Download PlumbingCAD</router-link></li>
            </ul>

            <ol class='help-listStyle q-mt-lg'>
                <li>
                    Run the program
                    <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>Click the '<span class='text-weight-medium'>Update my current Activation</span>' link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Reactivate link.jpg')" />
                </li>
                <li>
                    You will be prompted to login to your account to complete the remaining steps. (If you forget your password use the '<span class='text-weight-medium'>Forgot Password</span>' link to have it sent to your email.)
                </li>
                <li>
                    After you have completed the process your new Activation Code will be automatically applied, and a copy will sent to you by email. (If you later need to manually enter the Activation Code, see the <router-link to='/Support/Help/Enter-Activation'>Entering an Activation Code</router-link> help topic.)
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'software-activate',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>
